<template>
<div class="info">
	<div class="title">{{title||'申请人信息'}}</div>
	<Form :label-width="150" class="mt15">
	    <FormItem label="公司名称：" class="w600">
	        {{info.companyName}}
	    </FormItem>
		<FormItem label="证件类型：" class="w600">
	    	{{info.idTypeShow}}
	    </FormItem>
	    <FormItem label="证件号码：" class="w600">
	    	{{info.organizationCode}}
	    </FormItem>
	    <!-- <FormItem label="地区：" v-if="info.provinceName&&info.cityName&&info.areaName">
			{{info.provinceName+info.cityName+info.areaName}}
	    </FormItem> -->
		<FormItem label="通讯地址：" class="w600">
	        {{info.address}}
	    </FormItem>
		<FormItem label="联系人：" class="w600">
	        {{info.contactsName}}
	    </FormItem>
	    <FormItem label="邮政编码：" class="w600">
	        {{info.zipCode}}
	    </FormItem>
	    <FormItem label="联系电话：" class="w600">
	        {{info.contactsPhone}}
	    </FormItem>
	    <FormItem label="联系人邮箱：" class="w600">
	        {{info.contactsEmail}}
	    </FormItem>
		<FormItem label="企业性质：" class="w600">
	        {{info.enterpriseNatureShow}}
	    </FormItem>
		<FormItem label="行业分类：" class="w600">
	        {{info.industryCategoryShow}}
	    </FormItem>
		<FormItem label="营业范围：" class="w600">
	        {{info.businessScope}}
	    </FormItem>
	    <!-- <FormItem label="联系人证件号：" class="w600">
	        {{info.contactsCertificateNumber}}
	    </FormItem> -->
	    <!-- <FormItem label="营业执照：" class="w600" v-if="info.businessLicenseUrl">
	        <ImageShow :url="info.businessLicenseUrl" />
	    </FormItem> -->
		<FormItem 
			label="营业执照：" 
			class="w600">
			<div style="display:flex;flex-wrap:wrap;">
	        	<ImageShow :url="info.businessLicenseUrl"  v-if="info.businessLicenseUrl" />
				<UploadFileImg v-if="$route.query.orderType==1&&!info.correctUrl"
					@on-success="val=>uploadSuccess(val)" 
					:accept="['image']"
					style="width:100px">
					<div class="upload-img-main">
						<Icon type="ios-camera" size="20"></Icon>
						<p>点击上传</p>
					</div>
				</UploadFileImg>
			</div>
		</FormItem>
	</Form>
</div>
</template>
<script>
import ImageShow from '../../common/Image'
import UploadFileImg from '@/components/common/UploadFileImg'
export default {
	components:{ ImageShow,UploadFileImg },
	props:{
		info:Object,
		title:String
	},
	methods:{
		// 上传回调方法
		uploadSuccess(val,key){
			this.info.businessLicenseUrl=val.url
		},
		delImg (index) {
			this.info.businessLicenseUrl=''
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/pages/haierProduct/components/companyGroupEmployerGS/common/ApplicantInfo.vue